import Vue from "vue";
import Vuex from "vuex";
import BootstrapVue from "bootstrap-vue";
import { VLazyImagePlugin } from "v-lazy-image";
import VueCarousel from "vue-carousel";
import {
  FontAwesomeIcon,
  FontAwesomeLayers
} from "@fortawesome/vue-fontawesome";
import * as Sentry from "@sentry/browser";
import * as Integrations from "@sentry/integrations";
import { Integrations as TracingIntegrations } from "@sentry/tracing";
import vClickOutside from "v-click-outside";
import { AddToBasket } from "spiritweb.packages.ecommerce";
import WebAccount from "spiritweb.packages.web-account";
import VueUniqIds from "vue-uniq-ids";
import VueGoodshareLinkedIn from "vue-goodshare/src/providers/LinkedIn";
import VueGoodshareFacebook from "vue-goodshare/src/providers/Facebook";
import VueGoodshareTwitter from "vue-goodshare/src/providers/Twitter";
import BreadcrumbMenu from "~/Components/BreadcrumbMenu.vue";
import MegaMenu from "~/Components/MegaMenu.vue";
import QuickSearch from "~/Components/Search/QuickSearch.vue";
import Accordion from "~/Components/Accordion.vue";
import BasketQuantity from "~/Components/BasketQuantity.vue";
import JumpToTop from "~/Components/JumpToTop.vue";
import Author from "~/Components/Cards/Author.vue";
import store from "~/Scripts/store";
import HtmlEmbed from "~/Components/Base/HtmlEmbed.vue";
import FreeDownloadsList from "~/Components/Downloads/FreeDownloadsList.vue";

// eslint-disable-next-line
Vue.use( VueUniqIds, {} ); // required for search package (specifically filter directives: uni-for etc.)
Vue.use( WebAccount, { store } );
Vue.use( Vuex );
Vue.use( BootstrapVue );
Vue.use( VLazyImagePlugin );
Vue.use( VueCarousel );
Vue.use( vClickOutside );

Vue.component( "font-awesome-icon", FontAwesomeIcon );
Vue.component( "font-awesome-layers", FontAwesomeLayers );
Vue.component( "breadcrumb-menu", BreadcrumbMenu );
Vue.component( "mega-menu", MegaMenu );
Vue.component( "quick-search", QuickSearch );
Vue.component( "accordion", Accordion );
Vue.component( "add-to-basket", AddToBasket );
Vue.component( "basket-quantity", BasketQuantity );
Vue.component( "jump-to-top", JumpToTop );
Vue.component( "author", Author );
Vue.component( "vue-goodshare-facebook", VueGoodshareFacebook );
Vue.component( "vue-goodshare-twitter", VueGoodshareTwitter );
Vue.component( "vue-goodshare-linkedin", VueGoodshareLinkedIn );
Vue.component( "html-embed", HtmlEmbed );
Vue.component( "free-downloads-list", FreeDownloadsList );

const environment = document.querySelector( "meta[name=\"environment\"]" ).getAttribute( "content" );
Vue.prototype.$environment = environment;

const version = document.querySelector( "meta[name=\"version\"]" ).getAttribute( "content" );
Vue.prototype.$version = version;

const packageString = document.querySelector( "meta[name=\"package\"]" ).getAttribute( "content" );
Vue.prototype.$package = packageString;

const evdt = document.querySelector( "meta[name=\"evdt\"]" ).getAttribute( "content" ) === "true";
if ( evdt ) {
  Vue.config.devtools = true;
}

if ( process.env.NODE_ENV === "production" ) {
  Sentry.init( {
    dsn: "https://0e100fcaa84145348520297c970aefe3@o351484.ingest.sentry.io/6328258",
    environment,
    release: `${packageString}@${version}`,
    integrations: [
      new TracingIntegrations.BrowserTracing(),
      new Integrations.Vue( {
        Vue,
        attachProps: true,
        logErrors: true,
        tracing: true,
        tracingOptions: {
          trackComponents: true
        }
      } )
    ],
    denyUrls: [
      // Facebook flakiness
      /graph\.facebook\.com/i,
      // Facebook blocked
      /connect\.facebook\.net\/en_US\/all\.js/i,
      // Woopra flakiness
      /eatdifferent\.com\.woopra-ns\.com/i,
      /static\.woopra\.com\/js\/woopra\.js/i,
      // Chrome extensions
      /extensions\//i,
      /^chrome:\/\//i,
      // Other plugins
      /127\.0\.0\.1:4001\/isrunning/i, // Cacaoweb
      /webappstoolbarba\.texthelp\.com\//i,
      /metrics\.itunes\.apple\.com\.edgesuite\.net\//i
    ],
    tracesSampleRate: 0.05
  } );
}

const csrfToken = document.querySelector( "meta[name=\"csrf-token\"]" ).getAttribute( "content" );
Vue.prototype.$csrfToken = csrfToken;
